import {Component, OnInit} from '@angular/core';
import {BlogsHttpService} from '../../../../services/http-services/blogs/blogs-http.service';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {GrBlog} from '../../../../interfaces/blogs-interfaces';
import {ActivatedRoute} from '@angular/router';
import {BlogSectionType, BlogTypeEnum} from '../../../../enums/blog-enums';

@Component({
  selector: 'app-admin-single-blogs',
  templateUrl: './single-blog.component.html'
})
export class SingleBlogComponent implements OnInit {
    blog: GrBlog | null = null;
    urlParams: { blogId: number | undefined } = { blogId: undefined };
    public readonly BlogSectionType = BlogSectionType;
    protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

    constructor(private blogsHttpService: BlogsHttpService,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
      this.activatedRoute.params.subscribe(params => {
        this.urlParams.blogId = params.blogId;
        this.getSingleBlog();
      });
    }


    getSingleBlog(): void {
      this.blogsHttpService.getBlog(this.urlParams, true).then(response => {
        this.blog = response.data;
        this.blog.intro_text = this.blog.intro_text.replace(/&nbsp;/g, ' ');
        this.blog.sections.map((section: any) => {
          if (section.type === BlogSectionType.text) {
            section.value = section.value.replace(/&nbsp;/g, ' ');
          }
          return section;
        });
      });
    }


}
